import { ApiClient } from '../../../rest-api/fetsClient';
import { throwIfNotOk } from '../../../rest-api/throwIfNotOk';

export const createCourseExportModuleApi = (apiClient: ApiClient) => {
  const renameCourseExport = async (variables: { courseExportGuid: string; name: string }) => {
    const response = await apiClient['/api/course-exports/{courseExportGuid}'].put({
      params: { courseExportGuid: variables.courseExportGuid },
      json: { courseExportGuid: variables.courseExportGuid, name: variables.name },
    });
    await throwIfNotOk(response, 'rename the distribution module');
    return variables;
  };

  const deleteCourseExport = async (courseExportGuid: string) => {
    const response = await apiClient['/api/course-exports/{courseExportGuid}'].delete({
      params: { courseExportGuid },
    });
    await throwIfNotOk(response, 'delete the distribution module');
    return courseExportGuid;
  };

  return { renameCourseExport, deleteCourseExport };
};
